<template>
  <div class="cases-and-claims-summary">
    <div class="table-container" style="margin-top: 20px;">
      <!-- Tabla Simplificada para Cliente (HU-010) -->
      <el-table
        :data="list"
        row-key="id"
        v-loading="loadingSearch"
        class="dark-blue-table"
        size="mini"
        tooltip-effect="dark"
        @sort-change="handleSortChange"
        stripe
        style="width: 100%"
      >
        <el-table-column prop="caseNumber" :label="$t('casesAndClaims.caseNumber')" sortable align="center"></el-table-column>
        <el-table-column prop="statusClaim" :label="$t('casesAndClaims.status')" sortable="custom" align="center">
          <template slot-scope="scope">
            {{ getNameStatusClaim(scope.row.statusClaim) }}
          </template>
        </el-table-column>
        <el-table-column prop="isClaim" :label="$t('casesAndClaims.claim')" align="center">
          <template slot-scope="scope">
            <!--            <i v-if="scope.row.statusClaim === 2" class="el-icon-check"></i>-->
            <el-tooltip v-if="scope.row.isClaim" class="item" effect="dark" :enterable="false" :content="getYesNoTooltipLabel(scope.row.isClaim)" placement="top-start">
              <i class="el-icon-success green-success"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="invoiceNumber" :label="$t('casesAndClaims.invoiceNumber')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="pickupDate" :label="$t('casesAndClaims.pickupDate')" sortable="custom" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.pickupDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="dateTimeOpened" :label="$t('casesAndClaims.createdDate')" sortable="custom" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.dateTimeOpend) }}
          </template>
        </el-table-column>
        <el-table-column prop="subject" :label="$t('casesAndClaims.subject')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="loadNumber" :label="$t('casesAndClaims.loadNumber')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="billTo" :label="$t('casesAndClaims.billTo')" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
              effect="dark"
              :enterable="false"
              :content="scope.row.billToNameNumber"
              placement="top-start">
              <span>{{ scope.row.billToNameNumber }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="shipperId" :label="$t('casesAndClaims.shipper')" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
              effect="dark"
              :enterable="false"
              :content="scope.row.shipperNameNumber"
              placement="top-start">
              <span>{{ scope.row.shipperNameNumber }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="consigneeId" :label="$t('casesAndClaims.consignee')" sortable="custom" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
              effect="dark"
              :enterable="false"
              :content="scope.row.consigneeNameNumber"
              placement="top-start">
              <span>{{ scope.row.consigneeNameNumber }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="shipmentNumber" :label="$t('casesAndClaims.shipmentNumber')" sortable="custom" align="center"></el-table-column>
        <el-table-column prop="createdByUsername" :label="$t('casesAndClaims.creatorUser')" sortable="custom" align="center"></el-table-column>
        <el-table-column :label="$t('common.actions')" width="100" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('common.details')" placement="top">
              <detail-cases-and-claims :caseAndClaim="scope.row" :internal="isInternalUser"/>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" :content="$t('common.details')" placement="top">
            </el-tooltip>
            <add-cases-and-claims :caseAndClaim="scope.row"/>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-footer" v-show="total  > 0">
        <span class="el-pagination__total">
          <span class="el-pagination__title">{{ $t('casesAndClaims.totalCases') }}</span>
          {{ total }}
        </span>
        <el-pagination
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="actualFilters.rows"
          :current-page.sync="actualFilters.page"
          @current-change="handleCurrentChange"
          :total="total"
          layout="sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import constants from '@/utils/constants';
import AddCasesAndClaims from '@/views/customerCenter/casesAndClaims/components/addCasesAndClaims/AddCasesAndClaims';
import DetailCasesAndClaims from '@/views/customerCenter/casesAndClaims/components/detailCasesAndClaims/DetailCasesAndClaims';
import { CASES_AND_CLAIMS_INTERNAL } from '@/store/actions';

export default {
  name: 'ClientSearchSummary',
  components: {
    AddCasesAndClaims,
    DetailCasesAndClaims
  },
  data() {
    return {
      isInternalUser: null,
    };
  },
  computed: {
    ...mapState('clientCasesAndClaims', ['list', 'total', 'loadingSearch', 'actualFilters']),
  },
  created() {
    this.checkUserType();
  },
  methods: {
    ...mapActions('clientCasesAndClaims', ['searchList']),
    async checkUserType() {
      try {
        const response = await this.$store.dispatch(CASES_AND_CLAIMS_INTERNAL);
        this.isInternalUser = response.data || response;
      } catch (error) {
        this.isInternalUser = false; // Fallback
      }
    },
    getYesNoTooltipLabel(internal) {
      return internal ? constants.STATUS_BOOLEAN.yes.label : constants.STATUS_BOOLEAN.no.label;
    },
    handleSizeChange(val) {
      this.searchList({ rows: val });
    },
    handleCurrentChange(val) {
      this.searchList({ page: val });
    },
    formatDate(date) {
      if (!date) return '';
      return moment(String(date)).format('MM/DD/YYYY');
    },
    getNameStatusClaim(statusValue) {
      const status = constants.CASES_AND_CLAIMS.STATUS_CLAIM.find(s => s.value === statusValue);
      return status ? status.label : statusValue;
    },
    handleSortChange(data) {
      let order = null;
      if (data.order === 'ascending') {
        order = 'asc';
      } else if (data.order === 'descending') {
        order = 'desc';
      }
      if (order) {
        this.searchList({ orderField: data.prop, orderDirection: order });
      } else {
        this.searchList({ orderField: 'id', orderDirection: 'desc' });
      }
    }
  }
};
</script>

<style scoped>
.cases-and-claims-summary {
  padding: 20px;
}
</style>
